import React from 'react';
import PropTypes from 'prop-types';
import AuthRoute from './authRoute';
import useAppContext from '../context/useAppContext';
import Template from '../components/template/template';
import PageError from '../pages/error/pageError';

export default function AuthRouteOrganizer({ allow = [], path = '', fallback = null, children = null, isAdmin = true, ...routeProps }) {
    const [{ organization }] = useAppContext();

    const backHomeUrl = React.useMemo(() => {
        if (!organization) {
            return null;
        }

        return `/ticket/O${organization.id}/events`;
    }, [organization]);

    return (
        <AuthRoute
            allow={allow}
            path={path}
            isAdmin={isAdmin}
            fallback={
                fallback || (
                    <Template organization={organization}>
                        <PageError errorCode={403} backHomeUrl={backHomeUrl} />
                    </Template>
                )
            }
            {...routeProps}
        >
            {children}
        </AuthRoute>
    );
}

AuthRouteOrganizer.propTypes = {
    allow: PropTypes.array,
    path: PropTypes.string,
    children: PropTypes.node,
    fallback: PropTypes.node,
    isAdmin: PropTypes.bool
};
